import React from 'react';
import { InlineNotification } from '@carbon/react';
import { ASSET_TYPES, AssetType } from '../constants';

export const shouldShowNriNotification = (
  assetsData: any[],
  assetType: AssetType = ASSET_TYPES.CRM
): boolean => {
  if (!Array.isArray(assetsData) || !assetsData.length) return false;

  if (assetType === ASSET_TYPES.TITLE) {
    return false;
  }
  return defaultRoyaltyApplicable(assetsData);
};

export const nriBannerNotification = (
  shouldShowNriWarning: boolean,
  customRoyaltyRate?: string
): React.ReactNode => {
  const useCustomRoyaltyNotification =
    shouldShowNriWarning &&
    customRoyaltyRate !== undefined &&
    customRoyaltyRate !== 'None';

  if (useCustomRoyaltyNotification) {
    const subtitle = `Assets without a Royalty Rate have been assigned the value selected in 'Custom Royalty Rate,' which is currently set to ${customRoyaltyRate}. The columns populated with this custom royalty rate are highlighted in blue.`;

    return (
      <InlineNotification
        kind="info"
        title="Notice"
        subtitle={subtitle}
        hideCloseButton
      />
    );
  }

  if (shouldShowNriWarning) {
    const subtitle =
      'Net Revenue Interests (NRIs) showing 0 values could represent unleased assets. There is currently no custom royalty rate applied.';

    return (
      <InlineNotification
        kind="warning"
        title="Warning"
        subtitle={subtitle}
        hideCloseButton
      />
    );
  }

  return null;
};

export const defaultRoyaltyApplicable = (rows: any[]): boolean => {
  return rows.some((row) => !!row.defaultRoyaltyApplicable);
};
